// @flow
import { Link } from 'react-router';

const NavLink = Link;

export { Link, NavLink };
